import { createFileRoute } from "@tanstack/react-router";

import { VStack } from "@/components/Layout";
import { Separator } from "@/components/ui/separator";

import { InnerNavigation } from "./-components/InnerNavigation";
import BasicSettings from "./-components/sections/BasicSettings";
import DangerZone from "./-components/sections/DangerZone";

export const Route = createFileRoute("/_staff/ids/group-id/$id/_$id/settings/")(
  {
    component: Settings,
  },
);

function Settings() {
  return (
    <div
      className="grid h-full gap-10 pb-24 mx-auto mt-6"
      style={{ gridTemplateColumns: "240px 1024px" }}
    >
      <div className="relative pl-4">
        <InnerNavigation />
      </div>
      <div className="overflow-y-auto">
        <SettingItems />
      </div>
    </div>
  );
}

function SettingItems() {
  return (
    <VStack className="gap-6">
      <BasicSettings />
      <Separator />
      <DangerZone />
    </VStack>
  );
}
